import { Alert, Button, Flex, Skeleton, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CodeItem } from "@/pages/IntegrationsPage/components/molecules/CodeItem"
import {
  federatedCredentialCommand,
  identityCreateCommand,
  identityIdsCommand,
  roleAssignmentCommand
} from "@/pages/IntegrationsPage/helpers/acr"

import styles from "./AcrFederation.module.scss"

import type { AcrFederationProps } from "."

export const AcrFederation = ({
  federation,
  loginServer,
  failed,
  onRetry
}: AcrFederationProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.acr.federation"
  })

  return (
    <Flex vertical gap={12} className={styles.federation}>
      <Text strong>{t("title")}</Text>
      <Text type="secondary">{t("description")}</Text>
      {federation ? (
        <>
          <CodeItem
            withCopy
            titleLine1={t("identity")}
            codeSnippet={identityCreateCommand()}
          />
          <CodeItem
            withCopy
            titleLine1={t("credential")}
            titleLine2={t("credentialDetails", federation)}
            codeSnippet={federatedCredentialCommand(federation)}
          />
          <CodeItem
            withCopy
            titleLine1={t("role")}
            titleLine2={t("roleAbac")}
            codeSnippet={roleAssignmentCommand(loginServer)}
          />
          <CodeItem
            withCopy
            titleLine1={t("ids")}
            codeSnippet={identityIdsCommand()}
          />
        </>
      ) : failed ? (
        <Alert
          showIcon
          type="error"
          title={t("failed")}
          action={
            <Button size="small" onClick={onRetry}>
              {t("retry")}
            </Button>
          }
        />
      ) : (
        <Flex vertical gap={4}>
          <Text type="secondary">{t("loading")}</Text>
          <Skeleton.Input active size="small" />
        </Flex>
      )}
    </Flex>
  )
}
